
import { Subscription } from '@/services/types/subscriptionTypes';

/**
 * Проверяет и валидирует интервал подписки
 */
export const validateInterval = (interval?: string): 'day' | 'week' | 'month' | 'year' => {
  if (!interval) return 'month'; // По умолчанию месячный интервал
  
  switch (interval.toLowerCase()) {
    case 'day':
      return 'day';
    case 'week':
      return 'week';
    case 'month':
      return 'month';
    case 'year':
      return 'year';
    default:
      console.warn(`Некорректный интервал: ${interval}, используем 'month' по умолчанию`);
      return 'month';
  }
};

/**
 * Валидирует статус подписки и приводит его к допустимому значению
 */
export const validateSubscriptionStatus = (status?: string): "active" | "cancelled" | "paused" => {
  if (!status) return "active"; // По умолчанию активный статус
  
  switch (status.toLowerCase()) {
    case "active":
      return "active";
    case "cancelled":
      return "cancelled";
    case "paused":
      return "paused";
    default:
      console.warn(`Некорректный статус подписки: ${status}, используем 'active' по умолчанию`);
      return "active";
  }
};

/**
 * Возвращает человеко-читаемое название интервала
 */
export const getIntervalName = (interval?: string): string => {
  switch (interval) {
    case 'day':
      return 'Ежедневно';
    case 'week':
      return 'Еженедельно';
    case 'month':
      return 'Ежемесячно';
    case 'year':
      return 'Ежегодно';
    default:
      return 'Неизвестный интервал';
  }
};

/**
 * Проверяет, имеет ли подписка активный статус
 */
export const hasActiveSubscription = (subscription?: Subscription | null): boolean => {
  return subscription?.status === 'active';
};

/**
 * Возвращает название статуса подписки на русском языке
 */
export const getStatusName = (status?: string): string => {
  switch (status) {
    case 'active':
      return 'Активна';
    case 'paused':
      return 'Приостановлена';
    case 'cancelled':
      return 'Отменена';
    default:
      return 'Неизвестный статус';
  }
};
